// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12NkL","signatureBlock":"Footer_signatureBlock__1CtSm","signature":"Footer_signature__19wO-"};